require('../bootstrap');

import env from '../config/env';
import router from '../router/index';

const baseURL = env.baseURL;
const normalURL = env.normalURL;

function csrfCookieUrl() {
  try {
    const api = new URL(env.baseURL, window.location.origin);
    return api.origin + '/sanctum/csrf-cookie';
  } catch (e) {
    return '/sanctum/csrf-cookie';
  }
}

function applyUser(state, data) {
  state.authenticated = true;
  state.user.id = data.id;
  state.user.name = data.name;
  state.user.email = data.email;
  state.user.picture = data.photo;
  state.user.is_admin = data.is_admin;
  localStorage.setItem('is_admin', data.is_admin);
}

const store = {
  state: {
    user: {
      name: '',
      picture: '',
      job: '',
      email: '',
      id: 0,
      is_admin: false
    },
    authenticated: false,
    authInitialized: false,
    api: baseURL,
    url: normalURL,
    breadcrumbs: [{ name: "Home", route: "/" }],
    showProgress: false,
    progressMax: 100,
    progressValue: 0,
    showLoaderMessage: false,
    loaderMessage: ""
  },
  getters: {
    authenticated: state => state.authenticated,
    logo: state => state.logo,
    user: state => state.user,
    api: state => state.api,
    url: state => state.url,
    breadcrumbs: state => state.breadcrumbs,
    showProgress: state => state.showProgress,
    progressMax: state => state.progressMax,
    progressValue: state => state.progressValue,
    showLoaderMessage: state => state.showLoaderMessage,
    loaderMessage: state => state.loaderMessage,
  },
  mutations: {
    setAuthenticated(state, value) {
      state.authenticated = !!value;
    },
    setAuthInitialized(state, value) {
      state.authInitialized = !!value;
    },
    setUser(state, data) {
      applyUser(state, data);
    },
    clearAuth(state) {
      state.authenticated = false;
      state.user = {
        name: '',
        picture: '',
        job: '',
        email: '',
        id: 0,
        is_admin: false
      };
      localStorage.removeItem('is_admin');
    },
    // kept for backward compatibility with Login.vue commit('auth')
    auth(state, payload) {
      if (payload && typeof payload === 'object' && payload.id) {
        applyUser(state, payload);
      } else {
        state.authenticated = true;
      }
    },
    profileUpdate(state) {
      axios.post(state.api + 'me')
        .then(response => {
          applyUser(state, response.data);
        })
        .catch(() => {
          state.authenticated = false;
          router.push('/login');
        });
    },
    updateBreadCrumbs(state, newRoute) {
      if (state.breadcrumbs.length > 1) {
        state.breadcrumbs.pop();
      }
      state.breadcrumbs.push(newRoute);
    },
    setShowProgress(state, newValue) {
      state.showProgress = newValue;
    },
    setMaxProgressValue(state, newValue) {
      state.progressMax = newValue;
    },
    setProgressValue(state, newValue) {
      state.progressValue = newValue;
    },
    setShowLoaderMessage(state, newValue) {
      state.showLoaderMessage = newValue;
    },
    setLoaderMessage(state, newValue) {
      state.LoaderMessage = newValue;
    },
  },
  actions: {
    async ensureCsrf() {
      await axios.get(csrfCookieUrl());
    },
    async initialize({ commit, dispatch, state }) {
      try {
        await dispatch('ensureCsrf');
        const response = await axios.post(state.api + 'me');
        commit('setUser', response.data);
      } catch (e) {
        commit('clearAuth');
      } finally {
        commit('setAuthInitialized', true);
      }
    },
    async login({ commit, dispatch, state }, credentials) {
      await dispatch('ensureCsrf');
      const response = await axios.post(state.api + 'login', credentials);
      commit('setUser', response.data);
      return response;
    },
    async logout({ commit, dispatch }) {
      try {
        await dispatch('ensureCsrf');
        await axios.post(store.state.api + 'logout');
      } finally {
        commit('clearAuth');
      }
    }
  }
};

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js